var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'simpleToggle';

var	DEFAULTS = {
};

var SimpleToggle = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

SimpleToggle.prototype.initialise_ = function() {
	this.setProperties_();
	this.bindEvents_();
};

SimpleToggle.prototype.setProperties_ = function() {
	this.$target = $(this.$t.data('target'));
};

SimpleToggle.prototype.bindEvents_ = function() {
	var self_ = this;
	this.$t.on('click', function(e) {
		if ($(e.currentTarget).is(':checked')) {
			self_.$target.addClass('appeared');
		} else {
			self_.$target.removeClass('appeared');
		}
	});
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new SimpleToggle(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.simple-toggle.js